interface Item {
  label: string;
  valor: number;
}
interface Props {
  itens: Item[];
}

import { useEffect, useState } from 'react';

export function TopItemsBar({ itens }: Props) {
  const max = Math.max(1, ...itens.map((i) => i.valor));
  // monta com width 0 e anima até o pct alvo
  const [montado, setMontado] = useState(false);
  useEffect(() => {
    const t = window.setTimeout(() => setMontado(true), 30);
    return () => window.clearTimeout(t);
  }, [itens]);

  return (
    <ul className="flex flex-col gap-s4">
      {itens.map((it, i) => {
        const pct = (it.valor / max) * 100;
        return (
          <li
            key={i}
            className="flex flex-col gap-s2 animate-cardEnter"
            style={{ animationDelay: `${i * 60}ms` }}
          >
            <div className="flex items-baseline justify-between">
              <span className="font-body text-[13px] text-fg-1">{it.label}</span>
              <span className="font-mono text-[12px] text-fg-2 tnum">{it.valor}</span>
            </div>
            <div className="h-[6px] rounded-pill bg-card overflow-hidden">
              <div
                className="h-full rounded-pill"
                style={{
                  width: montado ? `${pct}%` : '0%',
                  background: 'linear-gradient(90deg, var(--moss-500), var(--moss-300))',
                  transition: `width 900ms cubic-bezier(0.16, 1, 0.3, 1) ${i * 60}ms`,
                }}
              />
            </div>
          </li>
        );
      })}
    </ul>
  );
}

export default TopItemsBar;
